import loginBg from "./assets/login-bg.jpg";
import { LOOPE_BEIGE } from "./colors";

export default {
  backgroundColor: {},
  container: {
    padding: "20px 10%",
    textAlign: "center",
  },
  logoContainer: {
    width: 200,
    display: "block",
    margin: "auto",
  },
  header: {
    color: "#fff",
    display: "none",
  },
  tag: {
    color: "#fff",
  },
};



// WEBPACK FOOTER //
// ./src/App.styles.js